import React, { useRef, useState, useEffect } from 'react';
import styles from './index.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import EcoImg from 'eco-design/base/eco-img';
import { LeftIcon, RightIcon } from '../icons';
import { useLang } from '@/i18n';
// import useCardsShowHook from '../useHooks/useCardsShowHook';

const DisasterPrevention: React.FC = () => {
    const swiperRef = useRef<any>(null);

    const { t } = useLang('Delta3AirStation.DisasterPrevention');
    const [slidesOffset, setSlidesOffset] = useState<any>(undefined);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const contentList: any = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1760942968473/1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761036093843/disaster-1-m.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761036093843/disaster-1-m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1762138750614/2-pc.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1762138499578/2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1762138499578/2.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1760942969084/3.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761036094304/disaster-3-m.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761036094304/disaster-3-m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1760942969288/4%20(2).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761036094716/disaster-4-m.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761036094716/disaster-4-m.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1760942968941/5.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761036094535/disaster-5-m.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761036094535/disaster-5-m.jpg',
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) {
                setSlidesOffset(24);
            } else if (window.innerWidth < 1024) {
                setSlidesOffset(48);
            } else if (window.innerWidth < 1340) {
                setSlidesOffset(120);
            } else {
                const offset = (window.innerWidth - 1200) / 2;
                setSlidesOffset(offset);
            }
        }
    }, []);

    // useCardsShowHook('#list-sence-disaster .power-swiper-slide', '#list-sence-disaster');

    return (
        <section className={`${styles.DisasterPrevention} GtmModuleData-section`} id="list-sence-disaster" data-section-id="DisasterPrevention">
            <div className="title-container">
                <div className="label">{t('label')}</div>
                <div className="title">{t('title')}</div>
                <div className="desc">{t('desc')}</div>
            </div>
            <div className="content-list">
                <Swiper
                    modules={[Navigation]}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    spaceBetween={14}
                    slidesPerView={'auto'}
                    slidesOffsetBefore={slidesOffset}
                    slidesOffsetAfter={slidesOffset}
                    onSlideChange={(swiper) => {
                        setIsBeginning(swiper.isBeginning);
                        setIsEnd(swiper.isEnd);
                    }}
                    onReachEnd={() => setIsEnd(true)}
                    onFromEdge={() => setIsEnd(false)}
                >
                    {contentList.map((item, index) => (
                        <SwiperSlide key={index} className="power-swiper-slide">
                            <div className="card-item">
                                <EcoImg className="power-swiper-img" pc={item.pc} pad={item.pad} h5={item.h5} isOpenLazy />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="swiper-btn-box">
                <span className={`btn-item ${isBeginning ? 'disabled' : ''}`} onClick={() => swiperRef.current?.slidePrev()}>
                    <LeftIcon />
                </span>
                <span className={`btn-item ${isEnd ? 'disabled' : ''}`} onClick={() => swiperRef.current?.slideNext()}>
                    <RightIcon />
                </span>
            </div>
        </section>
    );
};

export default DisasterPrevention;
